/* eslint-disable indent */
const trackingUtils = require('../modules/utils/tracking.utils');
const baggagesObserverMixin = require('../modules/mixins/baggages_observer.mixin');
const priceSubscriberMixin = require('../modules/mixins/price_subscriber.mixin');
const common = require('../modules/helpers/trip_summary_common');
const baggagesRowsCollection = require('../modules/collections/baggages_rows').getInstance();
const ShoppingCart = require('od-modules/cart/cart');

    Odigeo.defineWidget('trip_summary_price', Odigeo.Widget.extend(baggagesObserverMixin.extend({
        modelClass: Odigeo.Model.extend(priceSubscriberMixin.extend({
            dataURL: null,
            passengersInfoUrl: 'passengersInfo',
            finalPrice: null,

            init: function() {
                this.bindPriceCollection();
                this.on('priceCollection.repaintPrices', this.refreshView);
                ShoppingCart.subscribe(this.updatePrices.bind(this));
            },

            refreshView: function() {
                this.trigger('render', this.getPriceCollectionData());
                this.updatePrices();
            },

            updatePrices: function() {
                this.trigger('updatePrices', this.getFinalPrice(), this.getPricePerPassenger(), this.getSHPrice(), this.getPriceCollectionData());
            },

            getDataRequestSettings: function() {
                return {
                    type: 'GET',
                    cache: false,
                    success: Odigeo._.bind(this.requestSuccessHandler, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                };
            },

            url: function() {
                return Odigeo.Settings.getProperty('widgetPartUrlFormatter')(this.widget.name, this.passengersInfoUrl);
            },

            requestSuccessHandler: function(msg) {
                this.widget.view.updatePassengers(msg);
            },
            requestErrorHandler: function(xhr) {
                Odigeo.trigger(this.widget.id + ':requestError', xhr);
            },
            refreshPaxData: function() {
                this.isEmptyData = false;
                this.refresh();
            },
        })),

        viewClass: Odigeo.View.extend({

            initialTop: 0,
            finalTop: 0,
            fullBarHeight: 0,

            events: {
                'tap .change_details': 'changeToPassengerDetails',
                'tap .change_suggestion': 'sendUserToResults',
                'tap .change_hotel': 'changeHotel',
                'tap .remove_hotel': 'removeHotel',
                'tap .accommodation_toggle_details': 'accommodationToggleDetails',
                'tap .change_search': 'changeResults',
                'tap @addpaxAction': 'onAddpaxAction',
                'mouseenter .amount_discounted_tooltip': 'toggleTooltip',
                'mouseleave .amount_discounted_tooltip': 'toggleTooltip',
            },

            selectors: {
                'totalPrice': '.total_price',
                'totalPriceWithoutDiscount': '.total_price_without_discount',
                'dynpackFareDiscount': '.dynpack_fare_discount',
                'paxPrice': '.pax_price',
                'SH_price': '.SH_price',
                'baggageTable': '.baggage_table',
                'pax_list': '.pax_list',
                'seatmap_table': '.seatmap_table',
                'seat_map_all_price': '.seat_map_all_price',
                'seat_map_concept': '.seat_map_concept',
                'popup_disclaimer': '.popUpDisclaimer',
                'popup_trip_disclosure': '.trip_disclosure',
                'popup_pricebreakdown': '.result_price_breakdown',
                'help_desk_icon': '.help_desk_icon',
                'help_desk_label': '.help_desk_label',
                'hint_price_details': '.hint_price_details',
                'show_cc_type': '.show_cc_type',
                'show_cc_name': '.show_cc_name',
                'wrapper': '.wrapper_summary',
                'price_summary': '.price_summary',
                'pax_summary': '.pax_summary',
                'flights_summary': '.flights_summary',
                'accommodation_summary': '.accommodation_summary',
                'title_summary': '.title_summary',
                'removeHotel': '.remove_hotel',
                'owcSpecialRules': '.owc_special_rules',
                'trip_baggage_repricing': '.trip_baggage_repricing',
                'cheapestPaymentmethodDisclaimer': '.cheapest_paymentmethod_disclaimer',
                'baggagesTemplate': '.baggage_template',
                'baggagesTemplateSplitted': '.baggage_template_splitted',
                'baggagesDisclaimer': '.baggage_disclaimer',
                'passengersSection': '.passengers_tripsummary',
                'premiumPassengerSection': '.premium_passenger_tripsummary',
                'premiumPassengerName': '.premium_passenger_name_tripsummary',
                'membershipPriceDisplayCcFee': '.paymentfee.membership_price_display_cc_fee',
                'membershipPriceDisplayFeeText': '.membership_price_display_fee_text',
                'membershipPriceDisplayFeeValue': '.membership_price_display_fee_value',
                'membershipPriceDisplayDisclaimer': '.membership_price_display_disclaimer',
                'membershipPriceDisplayDisclaimerNoBtwnTrav': '.membership_price_display_disclaimer_no_btwn_trav',
                'membershipPriceDisplayDisclaimerTxt': '.disclaimer_txt',
                'addpaxAction': '.details_change_pax_button',
                'tripSummaryPriceWrapper': '.wrapper_summary.tripSummaryPriceWrapper',
                'premiumBubbleContent': '.bubble_sidebar_member_content',
                'premiumBubbleTemplate': '.bubble_sidebar_member_tmpl',
                'promocodeContainer': '.promocode_table',
                'priorityBoardingContainer': '.priority_boarding_container',
            },
            init: function() {
                if (this.widget.options.page === 'details') {
                    this.baggagesTemplate = Odigeo._.template(this.$cachedSelectors.baggagesTemplate.html(),
                        this.getTemplateSettings());

                    this.baggagesTemplateSplitted = Odigeo._.template(this.$cachedSelectors.baggagesTemplateSplitted.html(),
                        this.getTemplateSettings());
                }
                this.bindEvents();
                this.bindToDom();
                this.showPriceWithoutDiscountSelectedDisclaimer();
            },

            getTemplateSettings: function() {
                return Odigeo.Utils.getTmplSettings({variable: 'priceDescriptorsArray'});
            },

            bindEvents: function() {
                this.listenTo(this.model, 'updatePrices', this.repaintPrices);
            },

            repaintPrices: function(totalPrice, totalPricePax, totalPriceSH, priceCollectionData) {
                var vel = 200;
                var dynpackFareDiscount = parseFloat(this.$cachedSelectors['dynpackFareDiscount'].data('dynpackfarediscount')) || 0;
                var totalPriceWithoutDiscount = Odigeo.Utils.formatCurrency(priceCollectionData.totalPrice + dynpackFareDiscount);

                if (this.widget.options.page === 'payment' &&
                    this.$cachedSelectors.wrapper.data('sticky') &&
                    this.$cachedSelectors.price_summary.css('display') === 'table-footer-group') {
                    this.$cachedSelectors.totalPrice.hide().html(totalPrice).fadeIn(vel);
                    if (!Odigeo._.isUndefined(this.$cachedSelectors.paxPrice)) {
                        this.$cachedSelectors.paxPrice.hide().html(totalPricePax).fadeIn(vel);
                    }
                } else {
                    this.$cachedSelectors.totalPrice.html(totalPrice);
                    if (!Odigeo._.isUndefined(this.$cachedSelectors.paxPrice)) {
                        this.$cachedSelectors.paxPrice.html(totalPricePax);
                    }
                }
                if (!Odigeo._.isUndefined(this.$cachedSelectors.SH_price)) {
                    this.$cachedSelectors.SH_price.html(totalPriceSH);
                }
                if (!Odigeo._.isUndefined(this.$cachedSelectors.totalPriceWithoutDiscount)) {
                    this.$cachedSelectors.totalPriceWithoutDiscount.html(totalPriceWithoutDiscount);
                }
            },

            bindToDom: function() {
                var self = this;
                var trackingPage = Odigeo.History.getPageNameFromFragment();

                if (!this.isDomBinded) {
                    if (!Odigeo._.isEmpty(this.$cachedSelectors.popup_trip_disclosure)) {
                        Odigeo.UIElements.hint.enhance(trackingPage, this.$cachedSelectors.popup_trip_disclosure, {
                            events: {
                                tap: true,
                            },
                            googleAnalyticsOnOpen: {
                                type: 'trackEvent',
                                data: {
                                    page: trackingPage,
                                    action: 'trip_information',
                                    label: 'open_notes_tooltip',
                                },
                            },
                        });
                    }

                    if (!Odigeo._.isEmpty(this.$cachedSelectors.popup_disclaimer)) {
                        Odigeo.UIElements.hint.enhance(trackingPage, this.$cachedSelectors.popup_disclaimer, {
                            events: {
                                tap: true,
                            },
                            googleAnalyticsOnOpen: {
                                type: 'trackEvent',
                                data: {
                                    page: trackingPage,
                                    action: 'trip_information',
                                    label: 'open_secure_payment_tooltip',
                                },
                            },
                        });
                    }
                    if (!Odigeo._.isEmpty(this.$cachedSelectors.popup_pricebreakdown)) {
                        Odigeo.UIElements.hint.enhance(trackingPage, this.$cachedSelectors.popup_pricebreakdown, {
                            events: {
                                tap: true,
                            },
                            googleAnalyticsOnOpen: {
                                type: 'trackEvent',
                                data: {
                                    page: trackingPage,
                                    action: 'trip_information',
                                    label: 'open_price_breakdown',
                                },
                            },
                        });
                    }

                    if (this.$cachedSelectors.owcSpecialRules.length) {
                        trackingUtils.trackEvent('on_load', 'xfaring_info_loaded');
                        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.owcSpecialRules, {
                            events: {
                                tap: true,
                            },
                            googleAnalyticsOnOpen: {
                                type: 'trackEvent',
                                data: {
                                    action: 'xfaring_info',
                                    label: 'xfaring_info_clicked',
                                },
                            },
                        });
                    }

                    this.bindBaggageRepricing();
                    this.$cachedSelectors.help_desk_icon.on(Odigeo.Events.mouseover, function() {
                        self.$cachedSelectors.help_desk_label.removeClass('hidden');
                    });
                    this.$cachedSelectors.help_desk_icon.on(Odigeo.Events.mouseout, function() {
                        self.$cachedSelectors.help_desk_label.addClass('hidden');
                    });

                    this.isDomBinded = true;
                }
            },

            toggleTooltip: function(evt) {
                $(evt.currentTarget).toggleClass('open');
            },
            bindBaggageRepricing: function() {
                Odigeo._.each(this.$cachedSelectors.trip_baggage_repricing, function(popup) {
                    Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), popup, {
                        events: {
                            tap: true,
                        },
                    });
                });
            },
            unbindFromDom: function() {
                if (this.isDomBinded) {
                    this.$cachedSelectors.help_desk_icon.off(Odigeo.Events.mouseover);
                    this.$cachedSelectors.help_desk_icon.off(Odigeo.Events.mouseout);
                    this.$cachedSelectors.hint_price_details.off(Odigeo.Events.mouseover);
                    this.$cachedSelectors.hint_price_details.off(Odigeo.Events.mouseout);
                    $(window).off(Odigeo.Events.scroll);
                    this.isDomBinded = false;
                }
            },
            toggleCcType: function(show) {
                this.$cachedSelectors.show_cc_type.toggleClass('odf-hidden', !show);
            },
            setCcSelected: function(ccName) {
                this.$cachedSelectors.show_cc_name.html(ccName);
            },
            updateBaggagesView: function() {
                var items;
                var template = Odigeo.AB.isItineraryBagPriceSplitDesktop
                    ? this.baggagesTemplateSplitted : this.baggagesTemplate;

                if (Odigeo._.isFunction(template)) {
                    items = this.getBaggage();
                    this.$cachedSelectors.baggagesDisclaimer.toggleClass('odf-hidden', this.widget.getBaggageSelectedPieces() === 0);
                    this.$cachedSelectors.baggageTable.html(template(this.getBaggageTemplateData(items)));
                }

                this.$cachedSelectors.baggageTable.attr('data-all-price-baggage', this.widget.getBaggageSelectedTotalPrice());
                Odigeo.trigger('getTotalByFullprice', this.$widget);
            },
            getBaggage: function() {
                return Odigeo.AB.isItineraryBagPriceSplitDesktop
                    ? this.widget.getAllBaggagePriceBreakDownItems()
                    : this.widget.getBaggagePriceBreakDownItems();
            },
            getBaggageTemplateData: function(baggage) {
                if (!Odigeo.AB.isItineraryBagPriceSplitDesktop) {
                    return baggage;
                }

                var flightType = baggagesRowsCollection.getRequestType();

                return {
                    baggageInfo: this.widget.extendItineraryBaggage(baggage),
                    price: this.widget.getTotalPrice(baggage),
                    translations: this.widget.options.translations.flightTypes[flightType],
                };
            },

            showIncludedSeatMap: function(price) {
                var $seatmapTable = this.$cachedSelectors.seatmap_table;
                var $seatMapConcept;
                var $seatMapAllPrice;
                var seatMapConceptText;
                if (price.quantity > 0) {
                    $seatMapConcept = this.$cachedSelectors.seat_map_concept;
                    $seatMapAllPrice = this.$cachedSelectors.seat_map_all_price;
                    $seatmapTable.removeClass('hidden');
                    $seatmapTable.data('quantity-seatmap', price.quantity);
                    $seatMapAllPrice.html(Odigeo.Utils.formatCurrency(price.allprice));
                    $seatMapAllPrice.attr('data-allprice-seatmap', price.allprice);
                    seatMapConceptText = Odigeo.Utils.pluralizeAll($seatMapConcept.attr('data-plural'), price.quantity);
                    $seatMapConcept.html(seatMapConceptText);
                } else {
                    $seatmapTable.addClass('hidden');
                }
            },
            // Shows baggages when they are included by airline for free
            showIncludedBaggages: function(quantity) {
                this.$cachedSelectors.baggageTable.data('quantity-baggage', quantity);
                this.$cachedSelectors.baggageTable.text(quantity);
            },

            fillPax: function() {
                this.widget.model.refreshPaxData();
            },

            updatePassengers: function(data) {
                this.$widget.find('.pax_list').html(data);
                this.$widget.find('.pax_list').removeClass('hidden');
                this.updateDomSelectorsToCache();
                this.bindBaggageRepricing();
            },

            changeToPassengerDetails: function() {
                Odigeo.trigger(this.widget.id + ':changeBackPage');
            },

            sendUserToResults: function(ev) {
                var isIntermediatePage = $(ev.target).data('isUpsell');

                if (isIntermediatePage) {
                    Odigeo.Router.navigate('results');
                } else {
                    this.sendUserToDpResults(ev);
                }
            },

            changeResults: function changeResults(ev) {
                var to = $(ev.target).data('to');
                trackingUtils.trackEventWithCategory(to, 'searcher_flights', 'open_change_search');

                if (to !== 'flights_pax_page') {
                    Odigeo.Router.navigate('results');
                }
            },

            sendUserToDpResults: function(ev) {
                Odigeo.Session.remove('before-page');
                Odigeo.trigger(this.widget.id + ':sendUserToDpResults', $(ev.target).data('product'));
            },

            changeHotel() {
                Odigeo.Session.remove('before-page');
                Odigeo.trigger('sidebarFlightInfo:changeDPSelection', 'accommodation', true);
            },

            removeHotel: function() {
                const imgUrl = this.$el.find('.xsell_hotel_image').attr('src');
                if (!this.$cachedSelectors.removeHotel.data('disabled')) {
                    Odigeo.trigger(this.widget.id + ':removeHotel', imgUrl);
                }
            },

            accommodationToggleDetails: function(ev) {
                var optionsDetails = Odigeo._.clone($(ev.currentTarget).data('details'));
                var label = $(ev.currentTarget).data('label');
                var target = Odigeo.History.getPageNameFromFragment() + '_flights_container';
                var isOpen = this.$('#' + target).hasClass('open');

                ev.stopPropagation();
                optionsDetails.target = target;
                Odigeo.trigger(this.widget.id + ':toggleDetails', optionsDetails);

                if (!isOpen && label) {
                    trackingUtils.trackEvent('trip_information', label);
                }
            },

            disableRemoveHotel: function() {
                this.$cachedSelectors.removeHotel.data('disabled', true);
            },

            enableRemoveHotel: function() {
                this.$cachedSelectors.removeHotel.data('disabled', false);
            },

            confirmHotelRemoved: function() {
                this.$cachedSelectors.wrapper.addClass('hotel_removed');
            },
            showPriceWithoutDiscountSelectedDisclaimer: function() {
                if (!Odigeo._.isEmpty(this.$cachedSelectors.cheapestPaymentmethodDisclaimer)) {
                    var isPriceWithoutDiscountSelected = this.$cachedSelectors.cheapestPaymentmethodDisclaimer.data('isPriceWithoutDiscountSelected');
                    this.$cachedSelectors.cheapestPaymentmethodDisclaimer.toggleClass('odf-hidden', isPriceWithoutDiscountSelected);
                }
            },
            changePassengerSection: function(change) {
                this.$cachedSelectors.passengersSection.toggleClass('odf-hidden', change);
                this.$cachedSelectors.premiumPassengerSection.toggleClass('odf-hidden', !change);
            },
            displayPremiumDisclaimers: function(hasToDisplay, action) {
                var hideNoBtwnTravDsc = action === 'discount' || action === 'noDiscount' || hasToDisplay;
                this.$cachedSelectors.membershipPriceDisplayDisclaimerNoBtwnTrav.toggleClass('odf-hidden', hideNoBtwnTravDsc);
                this.$cachedSelectors.membershipPriceDisplayDisclaimer.toggleClass('odf-hidden', true);
            },
            updatePriceMemberDisplayPrices: function(action, isSubscriptionAdded) {
                common.updatePriceMemberDisplayPrices({
                    action: action,
                    isSubscriptionAdded: !!isSubscriptionAdded,
                    options: this.widget.options,
                    $cachedSelectors: this.$cachedSelectors,
                    $widget: this.$widget,
                });
            },
            renderPremiumBubble(membershipSettings) {
                return common.renderPremiumBubble({
                    membershipSettings: membershipSettings,
                    $cachedSelectors: this.$cachedSelectors,
                    options: this.widget.options,
                    templateSettings: Odigeo.Utils.getTmplSettings({variable: ''}),
                });
            },
            updatePriceMemberDisplay: function(action, isSubscriptionAdded) {
                var isLikeLoginAction = action === 'login' || isSubscriptionAdded || action === 'discount';
                this.displayPremiumDisclaimers(isLikeLoginAction, action);
            },
            updatePromocode: function(promoCode) {
                common.updatePromocode({
                    $cachedSelectors: this.$cachedSelectors,
                    promoCode: promoCode,
                    $widget: this.$widget,
                });
            },
            updateTravellersName: function(pax) {
                var conditions = (!Odigeo._.isUndefined(pax.id) && pax.id === 0) && Number(this.widget.options.numTravellers) === 1;
                this.$cachedSelectors.premiumPassengerName.html(pax.name);
                this.changePassengerSection(conditions);
            },
            onAddpaxAction: function() {
                Odigeo.trigger(this.widget.id + ':addPaxSidebar');
            },
            updatePricesWithMembershipSubscription: function(membershipPriceItem) {
                var membershipSubscriptionTable = this.$el.find('.membership_subscription_table');
                var shouldBeHidden = membershipPriceItem.allPrice === 0;

                membershipSubscriptionTable.toggleClass('odf-hidden', shouldBeHidden);
                membershipSubscriptionTable.find('.od-js-all-price').attr('data-all-price', membershipPriceItem.allPrice);
                membershipSubscriptionTable.find('.od-js-one-price').html(Odigeo.Utils.formatCurrency(membershipPriceItem.onePrice));
                membershipSubscriptionTable.find('.od-js-quantity').html(membershipPriceItem.quantity);
                membershipSubscriptionTable.find('.od-js-all-price').html(Odigeo.Utils.formatCurrency(membershipPriceItem.allPrice));
            },
            toggleClassToCachedSelectors: function(cachedSelectors, classes, add) {
                Odigeo._.each(cachedSelectors, Odigeo._.bind(function(cachedSelector) {
                    this.$cachedSelectors[cachedSelector].toggleClass(classes, add);
                }, this));
            },
            manageScroll: function(event) {
                if (!this.$cachedSelectors.wrapper.data('sticky')) {
                    return;
                }

                var tripSummaryPriceChildren = [
                    'title_summary',
                    'pax_summary',
                    'flights_summary',
                    'accommodation_summary',
                ];
                var scrollTop = event.scrollTop;
                var bodyHeight = event.bodyHeight;
                var footerTop = event.footerTop;
                var stickFooter;

                if (this.initialTop === 0) {
                    this.initialTop = this.$cachedSelectors.price_summary.offset().top;
                }
                if (this.fullBarHeight === 0) {
                    this.fullBarHeight = this.$cachedSelectors.tripSummaryPriceWrapper.height();
                }
                if (scrollTop > this.initialTop && event.paymentMainHeight > this.$el.height()) {
                    this.$cachedSelectors.wrapper.addClass('sticky');
                    this.toggleClassToCachedSelectors(tripSummaryPriceChildren, 'hidden', true);

                    this.finalTop = footerTop - this.$cachedSelectors.price_summary.height();

                    stickFooter = this.finalTop !== 0 && scrollTop > this.finalTop;

                    this.$cachedSelectors.wrapper.toggleClass('sticky-footer', stickFooter);

                    this.$cachedSelectors.wrapper.css({
                        top: stickFooter ? (bodyHeight - this.fullBarHeight) : '',
                    });

                    if (stickFooter) {
                        this.toggleClassToCachedSelectors(tripSummaryPriceChildren, 'hidden', false);
                    }
                } else {
                    this.$cachedSelectors.wrapper.removeClass('sticky sticky-footer');
                    this.toggleClassToCachedSelectors(tripSummaryPriceChildren, 'hidden', false);
                }
            },
        }),

        init: function() {
            this.bindEvents();
        },

        bindEvents: function() {
            this.suscribeBaggagesCollectionEvents();
        },

        onCollectionBuilt: function() {

        },

        onBaggageLoaded: function() {
            this.view.updateBaggagesView();
        },

        onBaggageChange: function(changedModel) {
            var selectedAttribute = changedModel.currentOption.get('selected');

            if (selectedAttribute) {
                this.view.updateBaggagesView();
            }
        },
        updateBubblePremium(membershipSettings) {
            return this.view.renderPremiumBubble(membershipSettings);
        },
        execute: function(func, params) {
            switch (func) {
                case 'showIncludedBaggages':
                    this.view.showIncludedBaggages(params);
                    break;
                case 'fillPax':
                    this.view.fillPax();
                    break;
                case 'disableRemoveHotel':
                    this.view.disableRemoveHotel();
                    break;
                case 'enableRemoveHotel':
                    this.view.enableRemoveHotel();
                    break;
                case 'confirmHotelRemoved':
                    this.view.confirmHotelRemoved();
                    break;
                case 'showIncludedSeatMap':
                    this.view.showIncludedSeatMap(params);
                    break;
                case 'setCcSelected':
                    this.view.setCcSelected(params);
                    break;
                case 'toggleCcType':
                    this.view.toggleCcType(params);
                    break;
                case 'updateTravellersName':
                    this.view.updateTravellersName(params);
                    break;
                case 'updatePriceMemberDisplay':
                    this.view.updatePriceMemberDisplay.apply(this.view, Odigeo._.tail(arguments));
                    break;
                case 'updatePriceMemberDisplayPrices':
                    this.view.updatePriceMemberDisplayPrices.apply(this.view, Odigeo._.tail(arguments));
                    break;
                case 'updatePromocode':
                    this.view.updatePromocode.apply(this.view, Odigeo._.tail(arguments));
                    break;
                case 'updatePrices':
                    this.model.updatePrices();
                    break;
                case 'updatePremiumDisclaimers':
                    this.view.displayPremiumDisclaimers(params);
                    break;
                case 'updatePremiumSidebarView':
                    var membershipPerks = params;
                    var isIncludedInPrice = membershipPerks.isIncludedInPrice;
                    if (membershipPerks.isMembershipPriceDisplay) {
                        this.view.displayPremiumDisclaimers(isIncludedInPrice);
                        this.view.changePassengerSection(isIncludedInPrice && +this.options.numTravellers === 1);
                        this.view.renderPremiumBubble({
                            isMemberTestActive: membershipPerks.isMembershipPriceDisplay,
                            isMemberLogged: membershipPerks.isMemberLoggedIn,
                            memberInTravellers: membershipPerks.isIncludedInPrice,
                            membershipPrice: membershipPerks.membershipPrice,
                        });
                    }
                    break;
                case 'updatePricesWithMembershipSubscription':
                    this.view.updatePricesWithMembershipSubscription(params);
                    break;
                case 'manageScroll':
                    this.view.manageScroll(params);
                    break;
            }
        },
    })));
